<template>
    <import-notice-common-new onlyRead></import-notice-common-new>
</template>
<script>
import importNoticeCommonNew from './importNoticeCommonNew';
export default {
    name: 'importNoticeRead',
    components: {
        importNoticeCommonNew
    }
}
</script>
